export default __webpack_public_path__ + "static/media/add-dinner-plan-plus.7a36ef7c.svg";